import { userSessionId } from 'app/features/user/selectors';

function captchaRequest(formType) {
  return (dispatch, getState, { api }) =>
    api.checkCaptcha({ formType, sessionId: userSessionId(getState()) });
}
export default captchaRequest;
